const LandingPage = () => import(/* webpackPrefetch: true */ './LandingPage.vue');
const EmployabilityPage = () => import(/* webpackPrefetch: true */ './EmployabilityPage.vue');
const EntrepreneurPage = () => import(/* webpackPrefetch: true */ './EntrepreneurPage.vue');

const routes = [
  {
    path: '/',
    name: 'home',
    component: LandingPage,
    meta: {
      title: 'Accueil',
      requiresAuth: false
    }
  },
  {
    path: '/parcours-employabilite',
    name: 'parcours-employabilite',
    component: EmployabilityPage,
    meta: {
      title: 'Parcours Employabilité',
      requiresAuth: false
    }
  },
  {
    path: '/parcours-entrepreneur',
    name: 'parcours-entrepreneur',
    component: EntrepreneurPage,
    meta: {
      title: 'Parcours Entrepreneur',
      requiresAuth: false
    }
  }
];

export default routes;

